import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addLTAType } from "common/services/ltas.service";
import Form from "./Form";
import { toast } from "react-toastify";

const AddLTAType: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
}> = ({ toggle, isModalOpen, fetchData }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      description: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      description: Yup.string(),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"],
          description: values["description"] || null,
        },
      };

      setLoading(true);
      try {
        await addLTAType(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("LTA type added successfully", {});
      } catch (e: any) {
        toast.error("LTA type creation failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Add LTA Type
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate={false}
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default AddLTAType;
